import React from 'react';
import styled from 'styled-components';
import { Icons } from 'autenti-components';
const Styled = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  width: 45px;
  height: 100%;
  z-index: 3;
  cursor: pointer;
`;
const ToggleIcon = ({ open, toggle }) => (React.createElement(Styled, { onClick: toggle }, open ? React.createElement(Icons.VisibilityOn, null) : React.createElement(Icons.VisibilityOff, null)));
export default ToggleIcon;
